import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Heading } from '../../components';

import { checkZoomSessionBuyerBookingThunk } from './ListingPage.duck';

import css from './SectionZoomMeetingLinkMaybe.module.css';

/**
 * Shows video call link for zoom-session listings: full URL for the provider or confirmed buyers; placeholder otherwise.
 */
const SectionZoomMeetingLinkMaybe = props => {
  const { listingId, publicData, currentUser, isOwnListing } = props;
  const dispatch = useDispatch();
  const [showFullLink, setShowFullLink] = useState(false);
  const [resolved, setResolved] = useState(false);

  const isZoom = publicData?.listingType === 'zoom-session';
  const meetingLink = publicData?.meetingLink;

  useEffect(() => {
    if (!isZoom || !meetingLink) {
      return;
    }
    if (isOwnListing) {
      setShowFullLink(true);
      setResolved(true);
      return;
    }
    if (!currentUser?.id) {
      setShowFullLink(false);
      setResolved(true);
      return;
    }

    dispatch(checkZoomSessionBuyerBookingThunk({ listingUuid: listingId.uuid }))
      .unwrap()
      .then(({ hasConfirmedBooking }) => {
        setShowFullLink(!!hasConfirmedBooking);
        setResolved(true);
      })
      .catch(() => {
        setResolved(true);
      });
  }, [isZoom, meetingLink, isOwnListing, currentUser, listingId, dispatch]);

  if (!isZoom || !meetingLink || !resolved) {
    return null;
  }

  return (
    <section className={css.root}>
      <Heading as="h2" rootClassName={css.heading}>
        Video call link
      </Heading>
      {showFullLink ? (
        <a
          href={meetingLink}
          target="_blank"
          rel="noopener noreferrer"
          className={css.link}
        >
          {meetingLink}
        </a>
      ) : (
        <p className={css.placeholder}>Video call link provided — available after booking</p>
      )}
    </section>
  );
};

export default SectionZoomMeetingLinkMaybe;
